import React, { useEffect, useState, useContext } from 'react';
import { Icon, Tooltip } from "antd";
import moment from 'moment';
import 'moment-timezone';
import {
    Table as TableStyle, PoolName, Input, ToTableFooter, TextTotal,
    ClearButton, TotalPercent, TotalSpan, TotalFixedText, ErrorMessage, ResetAll
} from './styles';
import { ColumnTitleMobile, ColumnValue, UnderlyingContent } from "../../styles";
import formatter from "../../../../../../utils/formatter";
import Context from '../../context';
import { RecommendAnExchangeAPIs } from '../../../../../../services/drupalServices';
import FundModal from './FundModal';
import { capitalizeText, isMobile } from '../../util';
import {AlertMessagePrimary} from '../popup/index';
import { AlertContent, Types } from '../../../../../../CommonComponents/ContentMessages';
import { recordError } from "../../../../../../utils/commonUtil";
import { replaceSelect } from '../../../../../../utils/replacer';


const newArray = (arr) => {
    return arr.map((item) => { return { ...item } });
}

const Table = (props) => {
    const { poolsData = {}, handleError, setDirty, isDirty, usedPercentage, setUsedPercentage, isNextClicked, setNextClicked } = props;
    const [portfolioSolutionsPool, setPortfolioSolutionsPool] = useState([]);
    const [portfolioBuildersPool, setPortfolioBuildersPool] = useState([]);
    const [valuesDrivenInvestmentPool, setValuesDrivenInvestmentPool] = useState([]);
    
    const { exchangeContext, setExchangeContext } = useContext(Context);
    const [isPoolModal, setPoolModal] = useState(false);
    const [fundData, setFundData] = useState([]);
    const [underlyingFundData, setUnderlyingFundData] = useState([]);
    const [resetPopUp, handleResetPopUp] = useState(false);

    useEffect(() => {
        let tmpPortfolioSolutionsPool = poolsData.portfolioSolutions ? newArray(poolsData.portfolioSolutions) : [];
        tmpPortfolioSolutionsPool = tmpPortfolioSolutionsPool.map((item) => {
            return {...item, _categoryType: 'portfolioSolutionsPool'}; // categoryType is used only for UI purpose
        });
        tmpPortfolioSolutionsPool.length > 0 && tmpPortfolioSolutionsPool.unshift({
            poolCategoryName: 'PORTFOLIO SOLUTIONS'
        });
        setPortfolioSolutionsPool(tmpPortfolioSolutionsPool);

        let tmpPortfolioBuildersPool = poolsData.portfolioBuilders ? newArray(poolsData.portfolioBuilders) : [];
        tmpPortfolioBuildersPool = tmpPortfolioBuildersPool.map((item) => {
            return {...item, _categoryType: 'portfolioBuildersPool'}; // categoryType is used only for UI purpose
        });
        tmpPortfolioBuildersPool.length > 0 && tmpPortfolioBuildersPool.unshift({
            poolCategoryName: 'PORTFOLIO BUILDERS'
        });
        setPortfolioBuildersPool(tmpPortfolioBuildersPool);

        let tmpValuesDrivenInvestmentPool = poolsData.valueDriven ? newArray(poolsData.valueDriven) : [];
        tmpValuesDrivenInvestmentPool = tmpValuesDrivenInvestmentPool.map((item) => {
            return {...item, _categoryType: 'valuesDrivenInvestmentPool'}; // categoryType is used only for UI purpose
        });
        tmpValuesDrivenInvestmentPool.length > 0 && tmpValuesDrivenInvestmentPool.unshift({
            poolCategoryName: 'Values-driven Investments'
        });
        setValuesDrivenInvestmentPool(tmpValuesDrivenInvestmentPool);

    }, [poolsData]);

    useEffect(() => {
        let percentage = 0
        if (portfolioSolutionsPool && portfolioSolutionsPool.length > 0) {
            percentage = portfolioSolutionsPool.reduce((acc, item) => acc + (item.percentage || 0), percentage);
        }
        if (portfolioBuildersPool && portfolioBuildersPool.length > 0) {
            percentage = portfolioBuildersPool.reduce((acc, item) => acc + (item.percentage || 0), percentage);
        }
        if (valuesDrivenInvestmentPool && valuesDrivenInvestmentPool.length > 0) {
            percentage = valuesDrivenInvestmentPool.reduce((acc, item) => acc + (item.percentage || 0), percentage);
        }

        setUsedPercentage(percentage);
        handleError(percentage !== 100);
        /** Update context with new data */
        let pools = [];
        pools = pools.concat(portfolioSolutionsPool.filter(item => item.percentage > 0));
        pools = pools.concat(portfolioBuildersPool.filter(item => item.percentage > 0));
        pools = pools.concat(valuesDrivenInvestmentPool.filter(item => item.percentage > 0));
        if (pools && pools.length > 0) {
            const context = { ...exchangeContext };
            context.to = { pools };
            setExchangeContext(context);
        }
    }, [portfolioSolutionsPool, portfolioBuildersPool, valuesDrivenInvestmentPool]);

    const onPercentageChange = ({ e, record, index }) => {
        var exp = /^\d{0,3}$/;
        if(exp.test(e.target.value)) {
            let pool;
            const inputValue = Number(e.target.value);
            switch (record._categoryType) {
                case 'portfolioSolutionsPool':
                    pool = newArray(portfolioSolutionsPool);
                    pool[index].percentage = inputValue;
                    setPortfolioSolutionsPool(pool);
                    break;
                case 'portfolioBuildersPool':
                    pool = newArray(portfolioBuildersPool);
                    pool[index].percentage = inputValue;
                    setPortfolioBuildersPool(pool);
                    break;
                case 'valuesDrivenInvestmentPool':
                    pool = newArray(valuesDrivenInvestmentPool);
                    pool[index].percentage = inputValue;
                    setValuesDrivenInvestmentPool(pool);
                    break;
            }
            // If input change is number then enable update
            if (inputValue >= 0) {
                setDirty(true);
            }
        }
    }

    const handleResetPools = () => {
        try {
            handleResetPopUp(true);
        } catch (error) {
          recordError(error);
        }
    }

    const clearPoolData = () => {
        let pool = portfolioSolutionsPool.map((item) => {
            return { ...item, percentage: 0 };
        });
        setPortfolioSolutionsPool(pool);
        pool = portfolioBuildersPool.map((item) => {
            return { ...item, percentage: 0 };
        });
        setPortfolioBuildersPool(pool);
        pool = valuesDrivenInvestmentPool.map((item) => {
            return { ...item, percentage: 0 };
        });
        setValuesDrivenInvestmentPool(pool);
        handleResetPopUp(false);
        setNextClicked(false)
    }

    const showPoolDetails = (value) => {
        try {
            const promises = [];
            promises.push(RecommendAnExchangeAPIs.getInvestmentFunds({ value }));
            promises.push(RecommendAnExchangeAPIs.getInvestmentUnderlyingFunds({ value }));
            Promise.all(promises).then((responses) => {
                setFundData(responses[0].data);
                setUnderlyingFundData(responses[1].data)
                setPoolModal(true)
            });
        } catch (error) {
          recordError(error);
        }
    }

    const columns = [
        {
            dataIndex: "poolCategoryName",
            key: "categoryName",
            className: "pool-category-name",
            render: (text, row, index) => {
                if (index === 0) {
                    return {
                        children:capitalizeText(row.poolCategoryName),
                        props: {
                            colSpan: 5
                        }
                    };
                }
                return {
                    props: {
                        colSpan: 0
                    }
                };
            }
        },
        {
            title: "Investment Options",
            dataIndex: "investmentOption",
            key: "investmentOption",
            className: "investment-pool-title hide-col-title-in-mobile",
            render: (value, row, index) => {
                if (index === 0) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    };
                }
                return (<PoolName onClick={(e) => showPoolDetails(value.replace(' Select', ''))}>{replaceSelect(value)}</PoolName>);

            },
            width: "24%"
        },
        {
            title: "Available Balance",
            className: "hide-col-title-in-mobile",
            key: "availableBalance",
            render: (value, row, index) => {
                if (index === 0) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    };
                }
                let colValue = row.availableBalance ? formatter({
                    value: row.availableBalance,
                    fieldSuffix: "Dollars"
                }) : '—';
                return <>
                    <ColumnTitleMobile>Available Balance</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            width: "25%"
        },
        {
            title: "Available Shares",
            className: "hide-col-title-in-mobile",
            key: "availableUnits",
            render: (value, row, index) => {
                if (index === 0) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    };
                }
                let colValue = row.availableUnits ? formatter({
                    value: row.availableUnits,
                    fieldSuffix: "Units"
                }) : '—';
                return <>
                    <ColumnTitleMobile>Available Shares</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            width: "25%"
        },
        {
            title: "Price per unit",
            className: "hide-col-title-in-mobile",
            dataIndex: "currentNav",
            key: "currentNav",
            render: (value, row, index) => {
                if (index === 0) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    };
                }
                const perUpdatedOn = 'Price updated on ' + moment(moment.tz(row.asOfDate, 'America/New_York')).format('MM/DD/YYYY')
                return (
                    <>
                        <ColumnTitleMobile>Price per unit</ColumnTitleMobile>
                        <ColumnValue>
                            <span>
                                {value ? 
                                    <Tooltip placement="bottomLeft" title={perUpdatedOn}>
                                        <UnderlyingContent>
                                        {`$${value.toFixed(2)}`} <Icon type={row.rise ? "caret-up" : "caret-down"} />
                                        </UnderlyingContent>
                                    </Tooltip>
                                    : ''}
                            </span>
                        </ColumnValue>
                    </>
                );
            },
            width: "17%"
        },
        {
            title: "Percentage",
            className: "hide-col-title-in-mobile",
            render: (text, record, index) => {
                if (index === 0) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    };
                }
                return (
                    <>
                        <ColumnTitleMobile>Percentage</ColumnTitleMobile>
                        <ColumnValue>
                            <Input
                                id={'txtPercentage' + record._categoryType + index}
                                value={record.percentage || ''}
                                onChange={e => onPercentageChange({ e, record, index })}
                                maxLength={3}
                                aria-label="percentageAllocation"
                            />
                        </ColumnValue>
                    </>
                );
            },
            key: "percentage"
        }
    ];

    const renderFooter = function () {
        return (
            <ToTableFooter className="flex">
                <TextTotal>Total</TextTotal>
                {usedPercentage > 0 &&
                    <ClearButton>
                        <ResetAll id="btnClearAll" onClick={handleResetPools}>Clear All</ResetAll>
                    </ClearButton>
                }
                <TotalPercent>
                    <TotalSpan>{`${usedPercentage}%`}</TotalSpan>
                    <TotalFixedText>out of 100.00%</TotalFixedText>
                </TotalPercent>
            </ToTableFooter>
        );
    };

    return (
        <>
            {portfolioSolutionsPool && portfolioSolutionsPool.length > 0 && <TableStyle
                showHeader={true}
                pagination={false}
                style={{ width: "100%" }}
                columns={columns}
                dataSource={portfolioSolutionsPool}
                rowKey={(record) => (record.id && record.id.toString()) || '0'}
            />}
            {portfolioBuildersPool && portfolioBuildersPool.length > 0 && <TableStyle
                showHeader={false}
                pagination={false}
                style={{ width: "100%" }}
                columns={columns}
                dataSource={portfolioBuildersPool}
                rowKey={(record) => (record.id && record.id.toString()) || '0'}
            />}
            {valuesDrivenInvestmentPool && valuesDrivenInvestmentPool.length > 0 && <TableStyle
                showHeader={false}
                footer={renderFooter}
                pagination={false}
                style={{ width: "100%" }}
                columns={columns}
                dataSource={valuesDrivenInvestmentPool}
                rowKey={(record) => (record.id && record.id.toString()) || '0'}
            />}
            {usedPercentage > 100 && <ErrorMessage>Total allocations must equal 100%</ErrorMessage>}
            {(usedPercentage < 100 && isNextClicked) && <ErrorMessage>Total allocations must equal 100%</ErrorMessage>}
            <FundModal
                visible={isPoolModal}
                poolUf={underlyingFundData}
                poolData={fundData}
                cancelOptionModal={setPoolModal}
            />
            <AlertMessagePrimary 
                className="altClearExchange"
                visible={resetPopUp} 
                title={<AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Clear To Exchange"}
                    property={"field_header"}
                    html={true}
                />}
                onOk={clearPoolData}
                onCancel={()=>handleResetPopUp(false)}
                cancelText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Clear To Exchange"}
                        property={"field_alert_button2_text"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Recommend an Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Clear To Exchange"}
                        property={"field_alert_button1_text"}
                        isButton={true}
                    />
                }
            >
                <AlertContent
                    page={"Recommend an Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Clear To Exchange"}
                    property={"field_description"}
                    html={true}
                />
            </AlertMessagePrimary>    
        </>
    );
};

export default Table;